{
  "Banking & Insurance": "Banking & Insurance",
  "Business Development": "Business Development",
  "Computer Science": "Computer Science",
  "Data Management": "Data Management",
  "Design": "Design",
  "Digital Awareness": "Digital Awareness",
  "Engineering": "Engineering",
  "Finance & Accounting": "Finance & Accounting",
  "IT Services": "IT Services",
  "Languages": "Languages",
  "Leadership": "Leadership",
  "Legal & Tax": "Legal & Tax",
  "Marketing & Communication": "Marketing & Communication",
  "Operational Excellence": "Operational Excellence",
  "Other": "Other",
  "People & Culture": "People & Culture",
  "Personal Development": "Personal Development",
  "Security & Risk": "Security & Risk",
  "Service, Sales & Advisory": "Service, Sales & Advisory",
  "Sustainability": "Sustainability",
  "You & Your Employer": "You & Your Employer"
}
